function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n", "\n\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { px2rem, getSpacing, getDisplay } from '../../utils/helpers';
var Buttons = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      direction = _ref.direction;
  var buttons = theme.buttons;
  return {
    display: 'flex',
    flexDirection: direction === 'horizontal' ? 'row' : 'column',
    '& > button:not(:first-child)': {
      marginLeft: direction === 'horizontal' ? px2rem(buttons.spaceBetween) : undefined,
      marginTop: direction === 'vertical' ? px2rem(buttons.spaceBetween) : undefined
    }
  };
}, function (_ref2) {
  var _ref3;

  var theme = _ref2.theme,
      direction = _ref2.direction,
      align = _ref2.align;
  var breakpoints = theme.breakpoints;

  if (direction !== 'horizontal') {
    return undefined;
  }

  return _ref3 = {
    justifyContent: align !== undefined && align.xs
  }, _ref3["@media (min-width: " + breakpoints.small + "px)"] = {
    justifyContent: align !== undefined && align.s
  }, _ref3["@media (min-width: " + breakpoints.medium + "px)"] = {
    justifyContent: align !== undefined && align.m
  }, _ref3["@media (min-width: " + breakpoints.large + "px)"] = {
    justifyContent: align !== undefined && align.l
  }, _ref3["@media (min-width: " + breakpoints.xlarge + "px)"] = {
    justifyContent: align !== undefined && align.xl
  }, _ref3["@media (min-width: " + breakpoints.xxlarge + "px)"] = {
    justifyContent: align !== undefined && align.xxl
  }, _ref3;
}, getSpacing, getDisplay);
Buttons.propTypes = {
  direction: PropTypes.oneOf(['horizontal', 'vertical'])
};
Buttons.defaultProps = {
  direction: 'horizontal'
};
export default Buttons;